export default __webpack_public_path__ + "static/media/DoubleRight.e41a4b11.svg";